export { Title, Component } from './Title';
